/**
 * iOS Compatibility Fix for Shopify Collection Grid
 * Risolve problemi con Safari mobile e iOS devices
 */

class iOSCompatibility {
  constructor() {
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    
    if (this.isIOS || this.isSafari) {
      this.init();
    }
  }

  init() {
    this.fixTouchHover();
    this.fixScrolling();
    this.fixLazyLoading();
    this.addIOSClass();
  }

  /**
   * Fix per hover su touch devices
   * Converte hover in touch events
   */
  fixTouchHover() {
    const hoverElements = document.querySelectorAll('.quickview--hover, .collection-product-card');
    
    hoverElements.forEach(element => {
      let touchTimeout;
      
      // Gestione touch start
      element.addEventListener('touchstart', (e) => {
        // Aggiungi classe hover
        element.classList.add('is-touched');
        
        // Rimuovi hover da altri elementi
        hoverElements.forEach(el => {
          if (el !== element) {
            el.classList.remove('is-touched');
          }
        });
      }, { passive: true });
      
      // Gestione touch end
      element.addEventListener('touchend', () => {
        // Mantieni hover per un breve periodo
        touchTimeout = setTimeout(() => {
          element.classList.remove('is-touched');
        }, 300);
      }, { passive: true });
      
      // Cancella timeout se si tocca di nuovo
      element.addEventListener('touchstart', () => {
        clearTimeout(touchTimeout);
      }, { passive: true });
    });
  }

  /**
   * Fix per smooth scrolling su iOS
   */
  fixScrolling() {
    // Aggiungi momentum scrolling
    const scrollContainers = document.querySelectorAll('.collection-product-list, .facets');
    
    scrollContainers.forEach(container => {
      container.style.webkitOverflowScrolling = 'touch';
      container.style.overflowScrolling = 'touch';
    });

    // Fix per infinite scroll / load more
    if (this.hasInfiniteScroll()) {
      this.fixInfiniteScroll();
    }
  }

  /**
   * Verifica se c'è infinite scroll attivo
   */
  hasInfiniteScroll() {
    return document.querySelector('[data-infinite-scroll]') !== null;
  }

  /**
   * Fix per infinite scroll su iOS
   */
  fixInfiniteScroll() {
    let isLoading = false;
    let scrollTimeout;

    const checkScroll = () => {
      if (isLoading) return;

      const scrollPosition = window.scrollY + window.innerHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const threshold = 200; // Carica 200px prima della fine

      if (scrollPosition >= pageHeight - threshold) {
        const loadMoreBtn = document.querySelector('.load-more-button, [data-load-more]');
        if (loadMoreBtn && !loadMoreBtn.disabled) {
          isLoading = true;
          loadMoreBtn.click();
          
          // Reset dopo caricamento
          setTimeout(() => {
            isLoading = false;
          }, 1000);
        }
      }
    };

    // Usa throttle per performance
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(checkScroll, 150);
    }, { passive: true });
  }

  /**
   * Fix per lazy loading delle immagini
   */
  fixLazyLoading() {
    // Forza caricamento immagini visibili su iOS
    if ('IntersectionObserver' in window) {
      const images = document.querySelectorAll('img[loading="lazy"]');
      
      const imageObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const img = entry.target;
            
            // Forza il caricamento
            if (img.dataset.src) {
              img.src = img.dataset.src;
            }
            
            // Rimuovi loading lazy per evitare problemi
            img.removeAttribute('loading');
            
            observer.unobserve(img);
          }
        });
      }, {
        rootMargin: '50px' // Carica un po' prima
      });

      images.forEach(img => imageObserver.observe(img));
    }
  }

  /**
   * Aggiungi classe per targeting CSS specifico iOS
   */
  addIOSClass() {
    document.documentElement.classList.add('is-ios');
    if (this.isSafari) {
      document.documentElement.classList.add('is-safari');
    }
  }
}

// Inizializza quando il DOM è pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new iOSCompatibility();
  });
} else {
  new iOSCompatibility();
}

// Re-inizializza dopo aggiornamenti AJAX (load more, filtri, etc)
document.addEventListener('shopify:section:load', () => {
  new iOSCompatibility();
});